import { render } from "./HeroApprovalLeaveModal.vue?vue&type=template&id=3b768806&scoped=true"
import script from "./HeroApprovalLeaveModal.vue?vue&type=script&lang=js"
export * from "./HeroApprovalLeaveModal.vue?vue&type=script&lang=js"

import "./HeroApprovalLeaveModal.vue?vue&type=style&index=0&id=3b768806&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b768806"]])

export default __exports__